// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".console-message-list {\n  margin-bottom: 20px;\n  word-break: \"break-word\";\n}\n.console-message-list .console-message {\n  margin-bottom: 14px;\n}\n.console-message-list h3 {\n  margin-bottom: 4px;\n}\n.console-message-list code {\n  padding: 5px;\n  display: block;\n}\n.console-message-list ul {\n  padding-left: 20px;\n}\n", ""]);
// Exports
module.exports = exports;
